import cx from 'clsx';
import React from 'react';

import SearchInput from '@/components/SearchInput';
import { DeviceType } from '@/logic/main/types';
import { isIFrameMode } from '@/logic/main/utils';
import { isHybrid888 } from '@/utils/isHybrid888';

import styles from './SearchBar.module.scss';

interface SearchInputPropsTypes {
  state?: 'active' | 'inactive';
  placeholder_new: {
    default: string;
    active: string;
  };
  placeholders: string[];
  clearText: string;
  search_modal_link: string;
  onSearchWrapperClick?: (args: { path: string }) => void;
  children?: React.ReactNode;
  deviceType: DeviceType;
  visible: boolean;
}

const SearchBar: React.FC<SearchInputPropsTypes> = ({
  children,
  state = 'active',
  placeholder_new,
  placeholders, // static texts for initial animation
  search_modal_link,
  onSearchWrapperClick,
  clearText,
  deviceType,
  visible = true,
}) => {
  if (!visible) return null;

  const isHybrid888App = isHybrid888();

  const onSearchClick = ({ path }: { path: string }) =>
    onSearchWrapperClick!({ path });

  return (
    <div
      className={cx(styles.wrapper, {
        [styles.desktop]: deviceType === 'desktop' && !isIFrameMode(),
        [styles.hybrid888]: isHybrid888App,
      })}
    >
      <SearchInput
        state={state}
        searchLink={search_modal_link}
        placeholderText_New={placeholder_new}
        placeholders={placeholders}
        onSearchWrapperClick={onSearchClick}
        clearText={clearText}
      />
      <div>{children}</div>
    </div>
  );
};

export default SearchBar;
